import { render, staticRenderFns } from "./ApprovalRouteBody.vue?vue&type=template&id=07d97083&scoped=true&"
import script from "./ApprovalRouteBody.vue?vue&type=script&lang=js&"
export * from "./ApprovalRouteBody.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalRouteBody.vue?vue&type=style&index=0&id=07d97083&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d97083",
  null
  
)

export default component.exports